import React from "react";

import LoadingOutlined from "@ant-design/icons/LoadingOutlined";

import { Empty } from "./styles";

type NotFoundComponentProps = {
  loading?: boolean;
  description?: React.ComponentProps<typeof Empty>["description"];
};

export const NotFoundComponent = ({
  loading = false,
  description,
}: NotFoundComponentProps) => {
  return (
    <Empty
      loading={loading ? "true" : "false"}
      image={
        loading && (
          <LoadingOutlined
            style={{
              fontSize: "48px",
              color: "rgba(0,0,0,0.45)",
            }}
            spin
          />
        )
      }
      description={loading ? "Carregando..." : description}
    />
  );
};
